import { useMediaQuery } from '@mui/material';
export var useSmMediaQuery = function () { return useMediaQuery('(max-width: 767px)', { noSsr: true }); }; // SM
export var useXlMediaQuery = function () { return useMediaQuery('(min-width: 1300px)', { noSsr: true }); }; // XL
export var underXlMediaQuery = function () { return useMediaQuery('(max-width: 991px)', { noSsr: true }); }; // SM & MD
